'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _extends = require('@babel/runtime/helpers/extends');
var react = require('@chakra-ui/react');
var React = require('react');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () {
            return e[k];
          }
        });
      }
    });
  }
  n["default"] = e;
  return Object.freeze(n);
}
var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var React__namespace = /*#__PURE__*/_interopNamespace(React);
var Svg = react.forwardRef(function (props, ref) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends__default["default"]({
    width: "1em",
    height: "1em",
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M4.147 4.94c-.162.465-.293.957-.39 1.475H2.03l-.614 1.706h2.138a15.708 15.708 0 0 0 0 1.707H2.03l-.614 1.706h2.34c.152.802.382 1.542.688 2.218.614 1.342 1.459 2.377 2.534 3.105 1.08.728 2.32 1.092 3.72 1.092a7.45 7.45 0 0 0 2.507-.427 5.992 5.992 0 0 0 2.099-1.28l-.136-.283-1.149-1.148a7.334 7.334 0 0 1-.652.425 5.488 5.488 0 0 1-1.254.537c-.443.131-.915.197-1.416.197a4.484 4.484 0 0 1-2.61-.802c-.774-.535-1.385-1.322-1.834-2.363a7.391 7.391 0 0 1-.411-1.271h4.9L9.036 9.828H5.604a13.955 13.955 0 0 1 0-1.707H7.33L4.147 4.94ZM10.93 6.415l1.64 1.64.755-1.64h-2.396ZM7.644 3.13a4.484 4.484 0 0 1 3.053-1.151c.49 0 .956.066 1.4.196.443.131.867.316 1.27.555.404.239.788.523 1.152.853l.819-1.774A6.55 6.55 0 0 0 13.23.469 6.78 6.78 0 0 0 10.697 0c-1.399 0-2.639.364-3.72 1.092-.269.183-.524.385-.765.606L7.644 3.13Z",
    fill: "currentColor"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.584 18 0 1.416 1.416 0 18 16.584 16.584 18Z",
    fill: "currentColor"
  }));
});
var EuroOff = react.forwardRef(function (props, ref) {
  return /*#__PURE__*/React__namespace.createElement(react.Icon, _extends__default["default"]({
    as: Svg
  }, props, {
    ref: ref
  }));
});
exports.EuroOff = EuroOff;